import { GoalsEffects } from './goals.effects';
import { MedicalQuestionsEffects } from './medical-questions.effects';
import { MedicationsEffects } from './medications.effects';
import { QuestionnaireEffects } from './questionnaire.effects';
import { QuestionsEffects } from './questions.effects';
import { SurveyEffects } from './survey.effects';
import { UserEffects } from './user.effects';
import { WomanHealthEffects } from './woman-health.effects';

export {
  GoalsEffects,
  MedicationsEffects,
  MedicalQuestionsEffects,
  QuestionnaireEffects,
  QuestionsEffects,
  SurveyEffects,
  UserEffects,
  WomanHealthEffects,
};

export const list = [
  GoalsEffects,
  MedicationsEffects,
  MedicalQuestionsEffects,
  QuestionnaireEffects,
  QuestionsEffects,
  SurveyEffects,
  UserEffects,
  WomanHealthEffects,
];
